import styled from "styled-components";

const ShoppingLinkContainer = styled.div`
  padding: 30px 0;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  margin-bottom: 70px;
  margin-top: 80px;

  @media (max-width: 575px) {
    margin-top: 0px;
    margin-bottom: 30px;
  }
`;

export default ShoppingLinkContainer;
